/** Labels for match picker options. */
export function formatMatchOption(m) {
  const parts = [`${m.home} vs ${m.away}`];
  if (m.score && String(m.score).includes('–')) parts.push(m.score);
  else if (m.kickoff) parts.push(m.kickoff);
  if (m.live) parts.push('LIVE');
  else if (m.status === 'finished' || m.finished) parts.push('FT');
  else if (m.upcoming) parts.push('Upcoming');
  return parts.join(' · ');
}

export function formatMatchSublabel(m) {
  const bits = [];
  if (m.kickoff && !String(m.score || '').includes('–')) bits.push(m.kickoff);
  if (m.venue) bits.push(m.venue);
  return bits.join(' · ') || null;
}
